import { inWindow } from '@/config';
import { enableSync } from './contact_sync_types';
export class ContactSyncScheduler {
    constructor(ctx, core, customer) {
        this.ctx = ctx;
        this.core = core;
        this.customer = customer;
    }
    setContactSync(options) {
        if (!inWindow()) {
            return;
        }
        const syncEnabled = enableSync(this.ctx);
        if (!syncEnabled) {
            return;
        }
        this.core.doSyncAction(options);
    }
    clearSyncAll() {
        if (process.env.BUILD_ISEDM) {
            this.ctx.systemApi.cancelEvent(this.customer.contactCustomerSyncHandle.eventPeriod, 'contactCustomerSync');
            this.ctx.contactEdmHelper.customerSyncTimes = 0;
        }
        this.ctx.contactDB.contactSyncTimes = 0;
    }
}
